import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSmoothScroll } from '../../motion/SmoothScroll';

const StickyCTA = () => {
  const [visible, setVisible] = useState(false);
  const { scrollTo, lenis } = useSmoothScroll() || {};
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => {
      const y = lenis?.scroll ?? window.scrollY;
      const pastHero = y > window.innerHeight * 0.65;
      const nearContact = (() => {
        const el = document.getElementById('contact');
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight * 0.85;
      })();
      setVisible(isHome && pastHero && !nearContact);
    };

    onScroll();
    if (lenis) {
      lenis.on('scroll', onScroll);
      return () => lenis.off('scroll', onScroll);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [lenis, isHome]);

  if (!isHome) return null;

  return (
    <div className={`scapia-sticky-cta ${visible ? 'is-visible' : ''}`}>
      <div>
        <strong>Ready to build?</strong>
        <p>Tell us about your site, brief, or idea.</p>
      </div>
      <a
        href="#contact"
        className="apple-cta"
        onClick={(e) => {
          e.preventDefault();
          if (scrollTo) scrollTo('#contact');
          else
            document
              .querySelector('#contact')
              ?.scrollIntoView({ behavior: 'smooth' });
        }}
      >
        Get in touch
      </a>
    </div>
  );
};

export default StickyCTA;
